import React, { useCallback, useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { NoRecords } from '../../Components/Shimmer';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
// import * as XLSX from 'xlsx-style';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { currentDateAndTime,decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';
import { SubmitButton } from '../../Components/InputElements';

const SalaryBankFile = () => {
    const { apiURL, apiHeaderJSON ,permissions } = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
     const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [rows, setRows] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);
    // const []
    const [filter, setFilter] = useState({
        company_bank_id: null,
        report_type: null,
        month: null,
    });
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });
    const reportType=[
        {value:"1", label:"Earned"},
        {value:"2", label:"Arrear"},
    ];

    const getList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCompanyBanks`, { params:{ activated: "1" }, headers })
        .then((response) => {
            const { success,data } = response.data;
            if (success === true) {
                console.log(data);
                const bankList = data?.map((val)=>{
                    return { value: val?.company_bank_id, label: val?.bank_name }
                })
                setBankOptions(bankList);
            }
        })
        .catch((error)=>{
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
    };

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterData)
                } else {

                }
            });
    };

    useEffect(() => {
        getList();
        getMonthFilterList();
    }, []);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((row) => {
                return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
            }));
        } else {
            setSelectedRows([]);
        }
    };
    // const handleExcelDownload = useCallback(() => {
    const handleExcelDownload = useCallback(() => {
        setLoadingExport(true);
        const headers = apiHeaderJSON;
        const data = {
            company_bank_id: filter?.company_bank_id,
            report_type: filter?.report_type,
            salary_month_year: filter?.month,
        }
        console.log("data =====>>>>", data);
        axios.post(`${apiURL}Payrolls/GetBankFile`, data, { headers})
        .then((response)=>{
            console.log(response);
            const { success, file_data, file_name, message } = response?.data;
            console.log("file_data",file_data);
            console.log("file_name",file_name);
            if (success === true) {

                const filteredData = file_data.slice(0);

                // Convert JSON to worksheet without headers
                const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });

                // Define column widths
                worksheet['!cols'] = [
                    { wch: 35 }, { wch: 23 },
                    { wch: 20 },  { wch: 15 },
                    { wch: 20 },  { wch: 15 },
                    { wch: 15 },  { wch: 10 },
                    { wch: 40 },  { wch: 30 },
                    { wch: 40 },  { wch: 40 },
                    { wch: 40 }, { wch: 40 },
                    { wch: 40 },
                ];

                // Apply wrap text to row 2
                const rowIndex = 1;

                Object.keys(worksheet).forEach((cellAddress) => {
                    const cell = worksheet[cellAddress];
                    const row = parseInt(cellAddress.replace(/[^0-9]/g, ''), 10);

                    if (row === rowIndex && cell && cell.v) {
                    cell.s = {
                        alignment: {
                        wrapText: true,
                        vertical: 'top',
                        },
                    };
                    }
                });

                // Create workbook and export
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');

                XLSX.writeFile(wb, file_name, { cellStyles: true });
            }
            Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: message,
                icon: success ? 'success' : 'error',
                showConfirmButton: true, 
                allowOutsideClick: false,
            });
            setLoadingExport(false);
        })
        .catch((error)=>{
            setLoadingExport(false);
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        })
    },[apiHeaderJSON, apiURL, filter]);



    const handleClearAll = useCallback(() => {
        setFilter({
            company_bank_id: null,
            report_type: null,
            month: null,
        });
        // setIsChanged(true);
    },[]);

    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Salary Bank File`} primary={`Home`} />
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className='col-md-3 position-relative mb-5'>
                                    <label className="form-label" >Bank</label>
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <Select onChange={(selectOption) => setFilter({ ...filter, company_bank_id: selectOption?.value })}
                                        disabled={!decodedData?.includes(6)}
                                        options={bankOptions}
                                        placeholder={`Select Bank`} 
                                        value={filter?.company_bank_id ? bankOptions.find(option => option.value === filter?.company_bank_id) : null}/>
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative mb-5'>
                                    <label className="form-label" > Salary Month </label>
                                    <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                        <Select onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                        disabled={!decodedData?.includes(6)}
                                        options={monthOptions}
                                        value={filter?.month ? monthOptions.find(option => option.value === filter?.month) : null}
                                        placeholder={`Select Month`} />
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative mb-5'>
                                    <label className="form-label" >Report Type</label>
                                    <div style={{ "zIndex": 8, "width": "90%" }} className=' position-absolute'>
                                        <Select onChange={(selectOption) => setFilter({ ...filter, report_type: selectOption?.value })}
                                        disabled={!decodedData?.includes(6)}
                                        options={reportType}
                                        value={filter?.report_type ? reportType.find(option => option.value === filter?.report_type) : null}
                                        placeholder={`Select Report Type`} />
                                    </div>
                                </div>
                                { decodedData?.includes(6) && (
                                    <div className='col-lg-3'>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-3 col-sm-12'>
                                                <label>Excel</label><br/>
                                                <SubmitButton onClick={handleExcelDownload}
                                                disabled={!filter?.company_bank_id || !filter?.month || !filter?.report_type} 
                                                loading={loadingExport}
                                                loadingMessage='Loading' buttonName={'Export'} icon={'ri-filter-3-fill'} 
                                                type='success' iconSide='left' />
                                            </div>
                                            <div className='col-lg-6 col-md-3 col-sm-12'>
                                                <label>Clear</label><br/>
                                                <SubmitButton onClick={handleClearAll}
                                                disabled={(!filter?.company_bank_id && !filter?.month && !filter?.report_type) || loadingExport} 
                                                buttonName={'Clear'} icon={'ri-database-2-line'} 
                                                type='secondary' iconSide='left' />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default SalaryBankFile;
